module.exports = __webpack_public_path__ + "static/images/pic_wuquanxian.7f3817b.7f3817b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_wuquanxian.7f3817b.png
// module id = /DSY
// module chunks = 0